import axios from "axios";
import APPLICATION_GLOBAL_CONFIG from "app/config/applicationGlobalConfig";
import queryClient from "app/config/queryClient";
import { authService, wipeQueryCache } from "app/services/auth/authentication";
import { redirectToConfiguredLogin } from "app/services/auth/loginRedirect";
import queryKeys from "shared/services/queryKeys";

const axiosInterceptor = axios.create({
    baseURL: APPLICATION_GLOBAL_CONFIG.apiBase,
    timeout: APPLICATION_GLOBAL_CONFIG.apiTimeout,
    withCredentials: true
});

// Request interceptor — ONLY prepare request
axiosInterceptor.interceptors.request.use((config) => {
    const token = authService.getAccessToken();
    const isFormData = typeof FormData !== "undefined" && config.data instanceof FormData;

    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`
        };
    }

    config.headers = {
        ...config.headers,
        ...(!isFormData ? { "Content-Type": "application/json" } : {}),
        Accept: "application/json"
    };

    return config;
});

// Response interceptor — handle auth
axiosInterceptor.interceptors.response.use(
    (response) => response,
    async (error) => {
        // const originalRequest = error.config;
        if (error.response?.status === 401) { // && !originalRequest._retry
            // let newToken = await authService.refreshToken();
            // if (newToken) {
            //     originalRequest._retry = true;

            //     return axiosInterceptor(originalRequest);
            // }

            // Só zera o cache na transição autenticado → sem sessão. Na tela de login um 401
            // é esperado (session_alive sem sessão); zerar ali remonta o portal, que refaz a
            // busca e recebe outro 401 — loop infinito.
            const hadSession = Boolean(queryClient.getQueryData(queryKeys.session.me()));
            authService.clearSession();
            if (hadSession) {
                wipeQueryCache();
            }
            redirectToConfiguredLogin();
        }
        return Promise.reject(error);
    }
);

export { axiosInterceptor };
